import {startLoading, stopLoading} from 'shared/actions/loading';
import {Action} from 'src/actions/utils';
import MicroScholarshipService from 'src/services/MicroScholarshipService';

export const RECEIVE_OPPORTUNITY_CARDS = 'RECEIVE_OPPORTUNITY_CARDS';
export const RECEIVE_OPPORTUNITY_CARD = 'RECEIVE_OPPORTUNITY_CARD';
export const LOADING_IDENTIFIER = 'microscholarships';

export const receiveOpportunityCards = (cards) => Action(RECEIVE_OPPORTUNITY_CARDS, {cards});
export const receiveOpportunityCard = (opportunityCard) =>
  Action(RECEIVE_OPPORTUNITY_CARD, {opportunityCard});

export const fetchOpportunityCards = () => async (dispatch) => {
  dispatch(startLoading(LOADING_IDENTIFIER));

  const [highSchoolActivities, opportunities] = await Promise.all([
    MicroScholarshipService.getPopularActivities(),
    MicroScholarshipService.getOpportunityCards(),
  ]);

  const cards = highSchoolActivities.concat(opportunities);

  dispatch(stopLoading(LOADING_IDENTIFIER));
  return dispatch(receiveOpportunityCards(cards));
};

export const fetchOpportunityCard = (opportunityCardType) => async (dispatch) => {
  opportunityCardType = opportunityCardType.charAt(0).toUpperCase() + opportunityCardType.substr(1);
  const activity = await MicroScholarshipService.getOpportunityCard(opportunityCardType);
  dispatch(receiveOpportunityCard(activity));
};
